<sc-master-detail [selection]="[selectedConstraint]" [data]="context.constraints"
  (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
  (deleteEntry)="onDeleteEntry($event);" [level]="2">

  <sc-padding [formGroup]="detailsFormGroup" fitHeight>

    <sc-flex vertical stretchContent fitHeight [gap]="16">

      <sc-string-field [required]="true" labelDictionaryKey="tmc-yard.entity.transport-option-constraint.name"
        formControlName="name"></sc-string-field>

      <sc-select-field formControlName="type" [data]="constraintTypeOptions"
        labelDictionaryKey="tmc-yard.entity.transport-option-constraint.type"></sc-select-field>

      <sc-number-field [required]="true" labelDictionaryKey="tmc-yard.entity.transport-option-constraint.count"
        formControlName="count"></sc-number-field>

      <sc-flex-fitting-content vertical>
        <app-constraint-option-assignment-editor [setOptions]="context.options" [setAssignedOptions]="assignedOptions"
          (assignedOptionsChanged)="onAssignedOptionsChanged($event)">
        </app-constraint-option-assignment-editor>
      </sc-flex-fitting-content>

    </sc-flex>

  </sc-padding>

</sc-master-detail>
